import * as React from "react";
const SvgRedo20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M16.874 13H12v2h8V7h-2v4.014a14.337 14.337 0 0 0-1.325-1.69C15.202 7.718 12.892 6 9.75 6S4.298 7.718 2.825 9.324a14.521 14.521 0 0 0-2.082 2.954 8.783 8.783 0 0 0-.139.277l-.009.019-.002.005-.001.003c0 .001-.001.001.908.418l-.909-.417-.417.91 1.818.833.416-.908.001-.001.003-.006a3.67 3.67 0 0 1 .103-.205 12.518 12.518 0 0 1 1.785-2.53C5.577 9.282 7.392 8 9.75 8s4.173 1.282 5.45 2.676A12.518 12.518 0 0 1 16.874 13Z",
      clipRule: "evenodd"
    })
  );
export default SvgRedo20Px;
